import {
  Box,
  Button,
  Paper,
  TextField,
  Typography,
  MenuItem,
  Snackbar,
  Autocomplete,
} from "@mui/material";
import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { useForm } from "react-hook-form";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import styles from "../../../styles.module.css";
import {
  ActionMsg,
  Breadcrumb,
  Cancel,
  CTSinput,
  HandleCloseSnackbar,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
import SaveIcon from "@mui/icons-material/Save";
import { useDispatch, useSelector } from "react-redux";
import {
  addUOMConversion,
  editDeleteUOMConversion,
  getProductList,
  getUOMList,
} from "../../../actions/actions";
import dayjs from "dayjs";
import uomConversionMasterService from "../../../services/masters/uomConversionMaster.Service";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const UOMConversionAdd = () => {
  let navigate = useNavigate();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;
  const dispatch = useDispatch();
  const { handleSubmit } = useForm();
  const urlLocation = useLocation();
  const editInfo = urlLocation.state;
  const editData = editInfo && editInfo;
  const [data, setData] = useState({
    prod_group: editData ? editData.prod_group : '',
    qty_kg: editData ? editData.qty_kg : 0,
    qty_cm3: editData ? editData.qty_cm3 : 0,
  });
  const [convertedValue, setConvertedValue] = useState("");

  const handleChange = ({ target }) => {
    const value = target.value;
    setData({
      ...data,
      [target.name]: value,
    });

    if (target.name === "qty" || target.name === "uom" || target.name === "prod_group") {
      calculateConvertedValue(
        target.name === "prod_group" ? value : data.prod_group,
        target.name === "qty" ? value : data.qty,
        target.name === "uom" ? value : data.uom
      );
    }
  };

  const calculateConvertedValue = (prodGroup, qty, uom) => {
    const conversionRates = {
      Oxygen: { sm3: 1, nm3: 1.0869, kgs: 1.55321, liters: 1.36068 },
      Nitrogen: { sm3: 1, nm3: 1.0869, kgs: 1.35899, liters: 1.68158 },
      Argon: { sm3: 1, nm3: 1.0869, kgs: 1.93867, liters: 1.39153 },
      Helium: { sm3: 1, nm3: 1.0869, kgs: 0.19391, liters: 1.55264 },
      Acetylene: { sm3: 1, nm3: 1.0869, kgs: 1.165, liters: 1 },
    };

    const rate = conversionRates[prodGroup] ? conversionRates[prodGroup][uom] : 1;
    const converted = parseFloat(qty) * rate;
    setData((prevData) => ({
      ...prevData,
      converted_value: converted,
    }));
    //setConvertedValue(converted);
    //setData(convertedValue)
    //console.log("converted", converted);
  };

  const [successMessage, setSuccessMessage] = useState(null);
  // const respMsgState = useSelector((state) => state.uom_conversion.message);
  // const { shouldShowMsg, responseMessage } = useMessageHandler(
  //   null,
  //   navigate,
  //   setSuccessMessage,
  //   respMsgState
  // );

  // useEffect(() => { }, [shouldShowMsg, responseMessage]);

  const onSubmit = async (event) => {
    const uomConversionData = {
      ...data,
      uom_con_id: editData ? editData.uom_con_id : null,
      modified_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      modified_by: editData ? userInfo.user_id : null,
      created_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      created_by: editData ? editData.created_by : userInfo.user_id,
      changedUpdatedValue: "edit",
    };
    try {
      if (editData) {
        await uomConversionMasterService.editDeleteUOMConversion(uomConversionData);
      } else {
        await uomConversionMasterService.addUOMConversion(uomConversionData);
      }
      setSuccessMessage(editData ? "Updated successfully" : "Added successfully");
      setTimeout(() => navigate(-1), 1000);
      //  setTimeout(()=>navigate(-1),1000);
    } catch (error) {
      setSuccessMessage("Error occurred");
    }
  };

  const prodGroupOptions = [
    { label: 'Oxygen', value: 'Oxygen' },
    { label: 'Nitrogen', value: 'Nitrogen' },
    { label: 'Helium', value: 'Helium' },
    { label: 'Argon', value: 'Argon' },
    { label: 'Acetylene', value: 'Acetylene' },
  ];

  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb routeSegments={[{ name: "UOM Conversion" }]} />


        <Box sx={{ display: "flex" }}>
          <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
            <Grid item md={7} sm={6} xs={12}>
              <Box sx={{ display: "flex" }}>
                <Typography className={`${styles.header_txt}`}>
                  {editData ? "Update" : "CREATE"} UOM CONVERSION MASTER
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>



        <Box>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                      }}
                    >
                      <Typography align="left"
                        className={`${styles.label_Txt_add}`}>
                        Product Group <span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <Autocomplete
                        disablePortal
                        options={prodGroupOptions}
                        clearIcon={false}
                        getOptionLabel={(option) =>
                          typeof option === 'string' ? option : option.label
                        }
                        value={
                          prodGroupOptions.find((opt) => opt.value === data.prod_group) || null
                        }
                        onChange={(event, newValue) => {
                          handleChange({
                            target: {
                              name: 'prod_group',
                              value: newValue ? newValue.value : '',
                            },
                          });
                        }}
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                        renderOption={(props, option) => (
                          <MenuItem {...props} className={styles.cts_lable}>
                            {option.label}
                          </MenuItem>
                        )}
                        renderInput={(params) => (
                          <CTSinput
                            {...params}
                            // label="Product Group"
                            // placeholder="Select or type product group"
                            required
                            size="small"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                              ...params.InputProps,
                              className: styles.CTSinput_Box,
                            }}
                          />
                        )}
                        sx={{ width: '100%' }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                      }}>
                      <Typography
                        className={`${styles.label_Txt_add}`} >
                        Qty KG <span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <CTSinput
                        size="small"
                        fullWidth
                        type="number"
                        onChange={handleChange}
                        name="qty_kg"
                        value={data.qty_kg}
                        required
                        InputProps={{
                          className: styles.CTSinput_Box,
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                      }}>
                      <Typography
                        className={`${styles.label_Txt_add}`} >
                        Qty CM3 <span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <CTSinput
                        size="small"
                        fullWidth
                        type="number"
                        onChange={handleChange}
                        name="qty_cm3"
                        value={data.qty_cm3}
                        required
                        InputProps={{
                          className: styles.CTSinput_Box,
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className={`${styles.grid_input}`}>
                <Box className={`${styles.btn_container}`}>
                  <Box>
                    <Button
                      id={`${styles.btn_save}`}
                      type="submit"
                    >
                      <SaveIcon className={`${styles.btn_cancel_txt}`} />{" "}
                      <Typography className={`${styles.btn_cancel_txt}`}> {editData ? "Update" : "Save"}</Typography>
                    </Button>
                  </Box>
                  <Box>
                    <Cancel />
                  </Box>
                </Box>
              </Grid>


            </Grid>
          </form>
        </Box>


        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};

export default UOMConversionAdd;